const BASE_URL = "https://twblyxzvdbhlhxxurpno.supabase.co/functions/v1/api"
const UNAUTHENTICATED_BASE_URL = "https://twblyxzvdbhlhxxurpno.supabase.co/functions/v1/unauthorised-api"
const EXPLORE_BASE_URL = "https://twblyxzvdbhlhxxurpno.supabase.co/functions/v1/explore"

export function getZipmapUrl(slug, sortType, coordinates) {
    return `${UNAUTHENTICATED_BASE_URL}/zipmap/${slug}?sort=${sortType}${coordinates ? `&currentCoordinates=${coordinates.latitude},${coordinates.longitude}` : ""}`
}

export function getZipmapPlaceDetailsUrl(placeId) {
    return `${UNAUTHENTICATED_BASE_URL}/zipmap/place/${placeId}`
}

export function getRouteUrl(mapSlug, routeSlug) {
    return `${UNAUTHENTICATED_BASE_URL}/zipmap/${mapSlug}/routes/${routeSlug}`
}

export function getRoutesByMapSlugUrl(mapSlug) {
    return `${UNAUTHENTICATED_BASE_URL}/zipmap/${mapSlug}/routes`
}

export function getCurationsUrl(curationId) {
    return `${BASE_URL}/curations/${curationId}`
}

export function getPublicCurationUrl(curationId) {
    return `${UNAUTHENTICATED_BASE_URL}/curation/${curationId}`
}

export function getDeleteCurationUrl(curationId) {
    return `${BASE_URL}/curations/${curationId}`
}

export function getUserCurationsUrl() {
    return `${BASE_URL}/curations`
}

export function getCreateCurationUrl() {
    return `${BASE_URL}/curations`
}

export function getJoinPublicCurationUrl(curationId) {
    return `${BASE_URL}/curations/${curationId}/join`
}

export function getSearchCurationsUrl(input) {
    return `${BASE_URL}/curations/search?searchInput=${input}`
}

export function getUpdateCurationUrl(curationId) {
    return `${BASE_URL}/curations/${curationId}`
}

export function getUpdateCurationCoverPhotoUrl(curationId) {
    return `${BASE_URL}/curations/${curationId}/cover`
}

export function getPlacesUrl(curationId) {
    return `${BASE_URL}/curations/${curationId}/places`
}

export function getPublicPlacesUrl(curationId) {
    return `${UNAUTHENTICATED_BASE_URL}/curations/${curationId}/places`
}

export function getCurationMembersUrl(curationId) {
    return `${BASE_URL}/curations/${curationId}/members`
}

export function getCurationPlaceSuggestionsUrl(curationId) {
    return `${BASE_URL}/curations/${curationId}/suggestions`
}

export function addPlaceSuggestionToCurationUrl(suggestionId, curationId) {
    return `${BASE_URL}/curations/${curationId}/suggestions/${suggestionId}`
}

export function generateInvitationLinkUrl(curationId) {
    return `${BASE_URL}/curations/${curationId}/invite/link`
}

export function getPlaceDetailsUrl(placeId) {
    return `${BASE_URL}/places/${placeId}`
}

export function getPublicPlaceDetailsUrl(placeId) {
    return `${UNAUTHENTICATED_BASE_URL}/places/${placeId}`
}

export function getPlacePreferencesUrl(placeId) {
    return `${BASE_URL}/places/${placeId}/preferences`
}

export function saveVisitUrl(placeId) {
    return `${BASE_URL}/places/${placeId}/visit`
}

export function getDeletePlaceUrl(placeId) {
    return `${BASE_URL}/places/${placeId}`
}

export function getPlaceCommentsUrl(placeId) {
    return `${BASE_URL}/places/${placeId}/comments`
}

export function getAddPlaceCommentUrl(placeId) {
    return `${BASE_URL}/places/${placeId}/comments`
}

export function getDeletePlaceCommentUrl(placeId, commentId) {
    return `${BASE_URL}/places/${placeId}/comments/${commentId}`
}

export function getPinPlaceCommentUrl(placeId, commentId) {
    return `${BASE_URL}/places/${placeId}/comments/${commentId}/pin`
}

export function getUnpinPlaceCommentUrl(placeId, commentId) {
    return `${BASE_URL}/places/${placeId}/comments/${commentId}/unpin`
}

export function getAddPlaceUrl() {
    return `${BASE_URL}/places`
}

export function getAddExtractedPlacesUrl() {
    return `${BASE_URL}/places/extracted`
}

export function getEditPlaceUrl(placeId) {
    return `${BASE_URL}/places/${placeId}`
}

export function getCopyPlaceUrl(placeId) {
    return `${BASE_URL}/places/${placeId}/copy`
}

export function getUploadPlaceImageUrl(placeId) {
    return `${BASE_URL}/places/${placeId}/images`
}

export function getFeedbackUrl() {
    return `${BASE_URL}/feedback`
}

export function getGooglePlacesAutocompleteUrl(searchInput) {
    return `${BASE_URL}/google/places/autocomplete?input=${searchInput}&key=AIzaSyCnf17r6a_GIVfD6Px-cMl9KMLaMgclhb4`
}

export function getGooglePlacesAutocompleteRegionUrl(searchInput) {
    return `${BASE_URL}/google/places/autocomplete/region?input=${searchInput}&key=AIzaSyCnf17r6a_GIVfD6Px-cMl9KMLaMgclhb4`
}

export function getGooglePlaceDetailsUrl(placeId) {
    return `${BASE_URL}/google/places//details?placeId=${placeId}`
}

export function getGooglePlaceIdFromShareUrl() {
    return `${BASE_URL}/google/places/share`
}

export function getExtractProgressUrl(curationId, progressId) {
    return `${BASE_URL}/curations/${curationId}/extract/${progressId}`
}

export function getUpdateFilterUrl(curationId, filterId) {
    return `${BASE_URL}/curations/${curationId}/filters/${filterId}`
}

export function getVerifyInviteCodeUrl() {
    return `${BASE_URL}/code`
}

export function getUserSignUpStatusUrl() {
    return `${BASE_URL}/user/enrollment`
}

export function getUpdateUserProfileUrl() {
    return `${BASE_URL}/user`
}

export function getUpdateUserProfilePictureUrl() {
    return `${BASE_URL}/user/picture`
}

export function exchangeGoogleIdTokenWithAuthCode() {
    return `${UNAUTHENTICATED_BASE_URL}/user/google/auth`
}

export function getUserProfileUrl() {
    return `${BASE_URL}/user`
}

export function getUserProfileByIdUrl(userId) {
    return `${BASE_URL}/user/${userId}`
}

export function getUpdateUserInterestsUrl() {
    return `${BASE_URL}/user/interests`
}

export function getUserInvitationsUrl() {
    return `${BASE_URL}/user/invitations/pending?rand=${(new Date()).getTime()}`
}

export function getSendInvitationUrl(curationId) {
    return `${BASE_URL}/curations/${curationId}/invite`
}

export function getAcceptInvitationUrl(invitationId) {
    return `${BASE_URL}/user/invitations/${invitationId}/accept`
}

export function getDeclineInvitationUrl(invitationId) {
    return `${BASE_URL}/user/invitations/${invitationId}/decline`
}

export function getAcceptInvitationLinkUrl(invitationLinkId) {
    return `${BASE_URL}/user/invitations/link/${invitationLinkId}/accept`
}

export function getDeclineInvitationLinkUrl(invitationLinkId) {
    return `${BASE_URL}/user/invitations/link/${invitationLinkId}/decline`
}

export function getDeleteAccountUrl() {
    return `${BASE_URL}/user`
}

export function getUpvotePlaceUrl(placeId) {
    return `${BASE_URL}/places/${placeId}/upvote`
}

export function getDownvotePlaceUrl(placeId) {
    return `${BASE_URL}/places/${placeId}/downvote`
}

export function getRemovePlaceVoteUrl(placeId) {
    return `${BASE_URL}/places/${placeId}/vote`
}

export function getUserMapsUrl() {
    return `${BASE_URL}/user/maps`
}

export function getAddMapUrl() {
    return `${BASE_URL}/maps`
}

export function getDeleteMapUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}`
}

export function getEditMapDescriptionUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}/description`
}

export function getEditMapNameUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}/name`
}

export function getEditMapSlugUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}/slug`
}

export function getEditMapPrimaryColorUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}/color/primary`
}

export function getUploadCoverPhotoUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}/cover`
}

export function getUploadLogoUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}/logo/light`
}

export function getUploadLogoDarkUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}/logo/dark`
}

export function getEditMapDefaultViewToListUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}/view/list`
}

export function getEditMapDefaultViewToMapUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}/view/map`
}

export function getPauseMapUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}/pause`
}

export function getStartMapUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}/start`
}

export function getEditMapIsSortAllowedUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}/sort`
}

export function getEditMapDefaultMarkerUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}/marker`
}

export function getEditMapPlaceUrl(mapSlug, placeId) {
    return `${BASE_URL}/maps/${mapSlug}/places/${placeId}`
}

export function getDeleteMapPlaceUrl(mapSlug, placeId) {
    return `${BASE_URL}/maps/${mapSlug}/places/${placeId}`
}

export function getUpdateMapPlacesSequenceUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}/places/sequence`
}

export function getAddMapPlaceUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}/places`
}

export function getMapMembersUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}/members`
}

export function getInviteMapMemberUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}/invite`
}

export function getInvitationDetailsUrl(invitationLinkId) {
    return `${UNAUTHENTICATED_BASE_URL}/invitations/${invitationLinkId}`
}

export function getSaveSupportTicketUrl() {
    return `${UNAUTHENTICATED_BASE_URL}/support/ticket`
}

export function getExploreRecordInteractionUrl(placeId) {
    return `${EXPLORE_BASE_URL}/places/${placeId}/record`
}

export function getExplorePlacesUrl(offset, seed, tags, googlePlaceId, bounds, placeName, ipInferredCityName, sortType, currentLocation) {
    return `${EXPLORE_BASE_URL}/places?offset=${offset}${seed ? `&seed=${seed}` : ""}${tags ? `&tags=${tags.join(",")}` : ""}${googlePlaceId ? `&googlePlaceId=${googlePlaceId}` : ""}${bounds ? `&bounds=${bounds}` : ""}${placeName ? `&placeName=${placeName}` : ""}${ipInferredCityName ? `&ipInferredCityName=${ipInferredCityName}` : ""}${sortType ? `&sort=${sortType}` : ""}${currentLocation ? `&currentCoordinates=${currentLocation.latitude},${currentLocation.longitude}` : ""}`
}

export function getExploreSearchHistoryUrl() {
    return `${EXPLORE_BASE_URL}/history`
}

export function getExploreSearchUrl(searchInput, offset, seed, googlePlaceId, bounds, placeName, currentLocation, ipInferredCityName, searchId) {
    return `${EXPLORE_BASE_URL}/search?input=${searchInput}&offset=${offset}${seed ? `&seed=${seed}` : ""}${googlePlaceId ? `&googlePlaceId=${googlePlaceId}` : ""}${bounds ? `&bounds=${bounds}` : ""}${placeName ? `&placeName=${placeName}` : ""}${currentLocation ? `&currentCoordinates=${currentLocation.latitude},${currentLocation.longitude}` : ""}${ipInferredCityName ? `&ipInferredCityName=${ipInferredCityName}` : ""}${searchId ? `&clientGeneratedId=${searchId}` : ""}`
}

export function getExploreSearchProgressUrl(clientSearchId) {
    return `${EXPLORE_BASE_URL}/search/progress/${clientSearchId}`
}

export function getAnalyticsPageViewUrl() {
    return `${UNAUTHENTICATED_BASE_URL}/analytics/web/pageview`
}

export function getAnalyticsActionUrl() {
    return `${UNAUTHENTICATED_BASE_URL}/analytics/web/action`
}

export function getMapDailyAnalyticsUrl(mapSlug) {
    return `${BASE_URL}/maps/${mapSlug}/analytics/daily`
}